import { render } from "./LiveItems.vue?vue&type=template&id=69d63afa&scoped=true"
import script from "./LiveItems.vue?vue&type=script&lang=js"
export * from "./LiveItems.vue?vue&type=script&lang=js"

import "./LiveItems.vue?vue&type=style&index=0&id=69d63afa&lang=less&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-69d63afa"]])

export default __exports__